import * as React from 'react';

import { CardBigNumbers } from 'src/component/shared';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareBillingMarketProps {
    data: any;
    loading: boolean;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareBillingMarketState {
    customFilter: {
        isChart: boolean
    },
}

export class MarketShareBookstoreShareBillingMarket extends React.Component<IMarketShareBookstoreShareBillingMarketProps, IMarketShareBookstoreShareBillingMarketState> {

    constructor(props: IMarketShareBookstoreShareBillingMarketProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
        }
    }

    public render() {
        const firstValue = (this.props.data && this.props.data.marketShareBookstoreShareBillingMarket != null 
            && this.props.data.marketShareBookstoreShareBillingMarket !== undefined) 
            ? this.props.data.marketShareBookstoreShareBillingMarket.current_year : null;

        const secondValue = (this.props.data && this.props.data.marketShareBookstoreShareBillingMarket != null 
            && this.props.data.marketShareBookstoreShareBillingMarket !== undefined) 
            ? this.props.data.marketShareBookstoreShareBillingMarket.last_year : null;

        return (
            <CardBigNumbers
                conversionType='MoneyLessBRL'
                loading={this.props.loading}
                firstValue={firstValue}
                secondValue={secondValue}
                title='Faturamento Mercado - 30 dias'
            />
        )
    }
    
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/marketShare/billingMarket/MarketShareBookstoreShareBillingMarket.tsx